/* Banky Nieuw WP2.2: leeszone van de productpagina (sections/banky-product-reading.liquid).
   Kerngegevens volgen de gekozen variant: bij Halo's variant:change krijgen EAN en artikelnummer de waarden van die
   variant (uit script[data-banky-varianten] in banky-product-keyfacts; alleen aanwezig als varianten verschillen).
   Varianten van andere producten (bijvoorbeeld een snelkooplade op dezelfde pagina) staan niet in die lijst en worden
   genegeerd. Inhoudsopgave en "Lees verder" doet bankyReading() in banky-sales.js (WP1.0). */
(() => {
  if (window.bankyProductReading) return;
  window.bankyProductReading = true;
  document.addEventListener('variant:change', e => {
    const variant = e.detail && e.detail.variant;
    if (!variant || variant.id === undefined) return;
    document.querySelectorAll('.banky-keyfacts').forEach(blok => {
      const bron = blok.querySelector('script[data-banky-varianten]');
      if (!bron) return;
      let lijst;
      try { lijst = JSON.parse(bron.textContent); } catch { return; }
      const waarden = lijst[String(variant.id)];
      if (!waarden) return;
      blok.querySelectorAll('[data-banky-variant-veld]').forEach(veld => {
        const waarde = waarden[veld.dataset.bankyVariantVeld];
        const rij = veld.closest('.banky-keyfacts__rij');
        if (waarde) { veld.textContent = waarde; if (rij) rij.hidden = false; }
        else if (rij) rij.hidden = true;
      });
    });
  });
  // USP-afbeelding (30-10-2026, snippets/banky-product-usp-banner.liquid). Alleen als een variant een eigen afbeelding heeft,
  // staat er een JSON-blok met per variant de bron (srcset, maten, sizes, alt; null = geen afbeelding). Bij variant:change
  // worden die gezet; eerst sizes, dan srcset, zodat de browser één keer kiest. Niets vooraf geladen: het nieuwe bestand
  // komt pas als het blok in beeld komt (loading lazy). Varianten die niet in de lijst staan (snelkooplade) negeren.
  document.addEventListener('variant:change', e => {
    const variant = e.detail && e.detail.variant;
    if (!variant || variant.id === undefined) return;
    document.querySelectorAll('[data-banky-usp-banner]').forEach(blok => {
      const bron = blok.querySelector('script[data-banky-usp-varianten]');
      if (!bron) return;
      let lijst;
      try { lijst = JSON.parse(bron.textContent); } catch { return; }
      const id = String(variant.id);
      if (!Object.prototype.hasOwnProperty.call(lijst, id)) return;
      const b = lijst[id];
      if (!b) { blok.hidden = true; return; }
      const source = blok.querySelector('source'), img = blok.querySelector('img');
      if (!source || !img) return;
      blok.style.setProperty('--banky-usp-d', b.dw + '/' + b.dh);
      blok.style.setProperty('--banky-usp-m', b.mw + '/' + b.mh);
      blok.classList.toggle('banky-usp-banner--smal', b.k === 'smal');
      blok.classList.toggle('banky-usp-banner--breed', b.k === 'breed');
      if (source.getAttribute('srcset') !== b.d) {
        source.setAttribute('sizes', b.ds); source.setAttribute('width', b.dw); source.setAttribute('height', b.dh);
        source.setAttribute('srcset', b.d);
      }
      if (img.getAttribute('srcset') !== b.m) {
        img.setAttribute('sizes', b.ms); img.setAttribute('width', b.mw); img.setAttribute('height', b.mh);
        img.setAttribute('srcset', b.m); img.setAttribute('src', b.src);
      }
      img.alt = b.alt || '';
      blok.hidden = false;
    });
  });
  // WP downloads (10-10-2026). "Alle specificaties": de kaart is ingeklapt gerenderd (banky-leeszone__kaart--dicht, alleen
  // zichtbaar met html.js, dus zonder sprong bij het laden); de knop klapt open en weer dicht. Wie onderaan dichtklapt,
  // gaat terug naar het begin van de kaart. Handleiding: een klik meet banky_handleiding_download in de dataLayer
  // (taal, producthandle en bestandsnaam; geen persoonsgegevens), het downloaden zelf doet de browser.
  // Specblad A2 (Geert 30-10-2026): open loopt dezelfde knop ("Lees minder") onderin beeld mee (CSS, sticky binnen de lijst).
  // Sluiten midden in de lijst: de knop blijft op precies dezelfde plek in beeld, nu weer met "Alle specificaties (n)";
  // past de dichte kaart helemaal in beeld (onder de vaste kop, scroll-margin-top van de kaart, plus 16px), dan schuift de
  // pagina in hetzelfde beeld net zo ver dat de hele kaart in beeld staat (desktop). Eén verschuiving vóór het volgende
  // beeld, zonder animatie; de focus blijft op de knop. Buiten het specblad (banky-bril-specs) zoals voorheen: wie onderaan
  // dichtklapt, gaat terug naar het begin van de kaart.
  const MARGE = 16;
  document.addEventListener('click', e => {
    const knop = e.target.closest && e.target.closest('[data-banky-specs-knop]');
    if (knop) {
      const kaart = knop.closest('.banky-leeszone__kaart');
      if (!kaart) return;
      if (!knop.dataset.tekstMeer) knop.dataset.tekstMeer = knop.textContent;
      const open = kaart.classList.contains('banky-leeszone__kaart--dicht');
      const specblad = !!kaart.closest('.banky-specblad');
      const voor = knop.getBoundingClientRect().top;
      kaart.classList.toggle('banky-leeszone__kaart--dicht', !open);
      knop.setAttribute('aria-expanded', String(open));
      knop.textContent = open ? knop.dataset.tekstMinder : knop.dataset.tekstMeer;
      if (open) return;
      if (!specblad) {
        if (kaart.getBoundingClientRect().top < 0) kaart.scrollIntoView({block: 'start'});
        return;
      }
      requestAnimationFrame(() => {
        if (knop.getAttribute('aria-expanded') === 'true') return;
        let dy = knop.getBoundingClientRect().top - voor;
        const r = kaart.getBoundingClientRect();
        const boven = (parseFloat(getComputedStyle(kaart).scrollMarginTop) || 0) + MARGE;
        const onderrand = innerHeight - MARGE;
        const top = r.top - dy, onder = r.bottom - dy;
        if (r.height <= onderrand - boven) {
          if (onder > onderrand) dy += onder - onderrand;
          else if (top < boven) dy += top - boven;
        }
        if (Math.abs(dy) > 0.5) window.scrollBy({top: dy, left: 0, behavior: 'instant'});
      });
      return;
    }
    const link = e.target.closest && e.target.closest('a[data-banky-handleiding]');
    if (link) {
      let bestand = '';
      try { bestand = decodeURIComponent(new URL(link.href, location.href).pathname.split('/').pop()); } catch { /* alleen meten */ }
      (window.dataLayer = window.dataLayer || []).push({
        event: 'banky_handleiding_download',
        banky_taal: link.dataset.bankyHandleiding || '',
        banky_product: link.dataset.bankyProduct || '',
        banky_bestand: bestand,
      });
    }
  });
})();
